import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import { Form, Input, Icon, Button, Row, Spin } from 'antd';

import './LoginForm.css';

import { withRouter } from 'react-router-dom';

@withRouter
@inject('authStore', 'translationsStore')
@observer
class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: false,
      loading: false
    };
  }
  handleSubmit = e => {
    e.preventDefault();
    const { authStore } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({ loading: true });
        const loginAction = authStore.newPasswordRequired ? authStore.completeNewPassword : authStore.login;
        loginAction
          .bind(this.props.authStore)(values)
          .then(() => ({}))
          .catch(error => ({ error }))
          .then(({ error }) => {
            this.setState({ loading: false }, () => {
              if (error) {
                this.setState({ message: error.message });
              } else {
                this.props.authStore.setIsLoggedIn(true);
              }
            });
          });
      }
    });
  };

  handleForgotPasswordUserClick = e => {
    e.preventDefault();
    //const { authStore } = this.props;
    //authStore.setShowForgotPasswordForm(true);
    // passaggio come componente sotto RouterAuth
    this.props.history.push('/forgot-password');
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { authStore, translationsStore } = this.props;
    return (
      <Spin spinning={this.state.loading}>
        <Form onSubmit={this.handleSubmit} className="LoginForm">
          <Form.Item>
            {getFieldDecorator('username', {
              rules: [{ required: true, message: translationsStore.translate('login.errorNoUsername') }]
            })(<Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder={translationsStore.translate('login.placeholderUsername')} />)}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('password', {
              rules: [{ required: true, message: translationsStore.translate('login.errorNoPassword') }]
            })(<Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder={translationsStore.translate('login.placeholderPassword')} />)}
          </Form.Item>
          {authStore.newPasswordRequired && (
            <Form.Item>
              {getFieldDecorator('newPassword', {
                rules: [{ required: true, message: translationsStore.translate('login.errorNoNewPassword') }]
              })(
                <Input
                  prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  type="password"
                  placeholder={translationsStore.translate('login.placeholderNewPassword')}
                />
              )}
            </Form.Item>
          )}
          <Form.Item>
            <a className="LoginFormForgot" href="" style={{ visibility: authStore.newPasswordRequired ? 'hidden' : 'visible' }} onClick={this.handleForgotPasswordUserClick}>
              <span>{translationsStore.translate('login.forgotpassword')}</span>
            </a>
            <Button type="primary" htmlType="submit" className="LoginFormButton">
              {!authStore.newPasswordRequired && <span>Log in</span>}
              {authStore.newPasswordRequired && <span>Save the new password</span>}
            </Button>
            <Row style={{ fontSize: '0.7rem', color: 'red' }}>{this.state.message}</Row>
          </Form.Item>
        </Form>
      </Spin>
    );
  }
}

export default Form.create()(LoginForm);



// WEBPACK FOOTER //
// ./src/components/Login/LoginForm.js